const baseUrl = 'https://api.ashish.me'
export default baseUrl
